const extendRecord = <T>(rec: Record<string, T>, ...x: Record<string, T>[]) => {
  const result = { ...rec };
  for (const y of x) {
    for (const k in y) {
      if (!Object.hasOwn(rec, k)) result[k] = y[k];
    }
  }
  return result;
}

export default extendRecord;